import React from "react";
var __jsx = React.createElement;
var DownArrowSVG = function DownArrowSVG(_ref) {
  var _ref$filledColor = _ref.filledColor,
    filledColor = _ref$filledColor === void 0 ? "#6C7A8D" : _ref$filledColor;
  return /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "7",
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83893 0.310934L6.00537 4.43546L10.1718 0.310934C10.5906 -0.103645 11.2671 -0.103645 11.6859 0.310934C12.1047 0.725513 12.1047 1.39522 11.6859 1.8098L6.75705 6.68907C6.33825 7.10364 5.66175 7.10364 5.24295 6.68907L0.314094 1.8098C-0.104698 1.39522 -0.104698 0.725513 0.314094 0.310934C0.732886 -0.0930144 1.42013 -0.103645 1.83893 0.310934Z",
    fill: filledColor
  }));
};
export default DownArrowSVG;